import { isUndefined } from 'lodash';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';

interface AhsayCredentials {
    ahsayLoginName: string;
    ahsayPasswordEncrypted: string;
}

class BsiApi {
    async onboarding(orgId: string, payload: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${process.env.REACT_APP_BSI}/onboarding-ahsay-user/${orgId}`,
                    payload
                )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }

    async updateContactDraft(orgId: string, payload: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${process.env.REACT_APP_BSI}/onboarding-ahsay-user/${orgId}/draft/contact`,
                    payload
                )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('Internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }

    async updateAccountDraft(orgId: string, payload: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${process.env.REACT_APP_BSI}/onboarding-ahsay-user/${orgId}/draft/account`,
                    payload
                )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('Internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }

    async updateAddressDraft(orgId: string, payload: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${process.env.REACT_APP_BSI}/onboarding-ahsay-user/${orgId}/draft/address`,
                    payload
                )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('Internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }

    async submitConfirmationDraft(orgId: string, payload: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${process.env.REACT_APP_BSI}/onboarding-ahsay-user/${orgId}/draft/confirmation`,
                    payload
                )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('Internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }

    async getDraft(orgId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.REACT_APP_BSI}/onboarding-ahsay-user/${orgId}/draft`)
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response.data);
                    } else {
                        reject(new Error('Internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }



    async getAhsayCredentials(): Promise<AhsayCredentials> {
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.REACT_APP_BSI}/ahsay-user/credentials`)
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response.data);
                    } else {
                        reject(new Error('Internal Server Error'));
                    }
                })
                .catch((error) => {
                    logger(error, 'error');
                    reject(error);
                });
        });
    }
}
export const bsiApi = new BsiApi();
